module.exports = __webpack_public_path__ + "img/partido-nacionalista.d78fd900.png";